<template>
  <v-app v-if="route.name">
    <div v-if="isFullLayoutVisible" :duration="DURATION" class="idle" @idle="onLogout" />

    <core-toolbar v-if="isFullLayoutVisible" />
    <core-drawer v-if="isFullLayoutVisible" />

    <core-view />
  </v-app>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import CoreView from '@/layout/View.vue';
import CoreToolbar from '@/layout/Toolbar.vue';
import CoreDrawer from '@/layout/Drawer.vue';
import { DURATION } from '@/constants';
import useAuthStore from '@/store/modules/pinia/auth';
import handleLogout from '@/helpers/auth-helper';

const route = useRoute();
const authStore = useAuthStore();

const isFullLayoutVisible = computed(() => {
  const isUserIn = authStore.isLoggedIn();
  const excludedRoutes = ['Login', 'Guacamole Client'];
  return isUserIn && !excludedRoutes.includes(route.name);
});

const onLogout = async () => {
  try {
    await handleLogout();
  } catch (e) {
    console.debug('Error during idle logout:', e);
  }
};

window.addEventListener('logout-required', () => {
  handleLogout();
});
</script>

<style lang="scss">
.idle {
  display: none;
}
</style>
